import React, { useState } from 'react';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import { BarChart3Icon, LineChartIcon, DownloadIcon, ShareIcon, CalendarIcon, FilterIcon } from 'lucide-react';
const Reports = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-376">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-377" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-378" />
      <main className="p-4 pb-20" data-id="element-379">
        <div className="flex justify-between items-center mb-4" data-id="element-380">
          <h1 className="text-xl font-semibold" data-id="element-381">Informes y Dashboards</h1>
          <div className="flex space-x-2" data-id="element-382">
            <button className="p-2 text-gray-600 bg-white border border-gray-300 rounded-lg" data-id="element-383">
              <FilterIcon size={20} data-id="element-384" />
            </button>
            <button className="p-2 text-gray-600 bg-white border border-gray-300 rounded-lg" data-id="element-385">
              <CalendarIcon size={20} data-id="element-386" />
            </button>
          </div>
        </div>
        {/* Summary Cards */}
        <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-387">
          <Card className="bg-blue-50" data-id="element-388">
            <div className="text-sm text-gray-600" data-id="element-389">Acuerdos totales</div>
            <div className="text-xl font-bold text-blue-700" data-id="element-390">156</div>
          </Card>
          <Card className="bg-green-50" data-id="element-391">
            <div className="text-sm text-gray-600" data-id="element-392">Recaudo mensual</div>
            <div className="text-xl font-bold text-green-700" data-id="element-393">$24.5M</div>
          </Card>
          <Card className="bg-amber-50" data-id="element-394">
            <div className="text-sm text-gray-600" data-id="element-395">Pendientes</div>
            <div className="text-xl font-bold text-amber-700" data-id="element-396">32</div>
          </Card>
          <Card className="bg-purple-50" data-id="element-397">
            <div className="text-sm text-gray-600" data-id="element-398">Conversión</div>
            <div className="text-xl font-bold text-purple-700" data-id="element-399">68%</div>
          </Card>
        </div>
        {/* Bar Chart */}
        <Card className="mb-6" data-id="element-400">
          <div className="flex justify-between items-center mb-4" data-id="element-401">
            <h2 className="font-semibold" data-id="element-402">Acuerdos por mes</h2>
            <div className="flex space-x-2" data-id="element-403">
              <button className="p-1 text-gray-600 hover:text-blue-600" data-id="element-404">
                <DownloadIcon size={18} data-id="element-405" />
              </button>
              <button className="p-1 text-gray-600 hover:text-blue-600" data-id="element-406">
                <ShareIcon size={18} data-id="element-407" />
              </button>
            </div>
          </div>
          <div className="flex items-end h-40 space-x-2 mb-2" data-id="element-408">
            {[35, 50, 65, 45, 60, 75].map((value, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-409">
                <div className="w-full bg-blue-500 rounded-t-sm" style={{
              height: `${value}%`
            }} data-id="element-410"></div>
              </div>)}
          </div>
          <div className="flex justify-between text-xs text-gray-500" data-id="element-411">
            <div data-id="element-412">Ene</div>
            <div data-id="element-413">Feb</div>
            <div data-id="element-414">Mar</div>
            <div data-id="element-415">Abr</div>
            <div data-id="element-416">May</div>
            <div data-id="element-417">Jun</div>
          </div>
        </Card>
        {/* Line Chart */}
        <Card className="mb-6" data-id="element-418">
          <div className="flex justify-between items-center mb-4" data-id="element-419">
            <h2 className="font-semibold" data-id="element-420">Recaudo mensual</h2>
            <div className="flex space-x-2" data-id="element-421">
              <button className="p-1 text-gray-600 hover:text-blue-600" data-id="element-422">
                <DownloadIcon size={18} data-id="element-423" />
              </button>
              <button className="p-1 text-gray-600 hover:text-blue-600" data-id="element-424">
                <ShareIcon size={18} data-id="element-425" />
              </button>
            </div>
          </div>
          <div className="relative h-40 mb-2" data-id="element-426">
            {/* Simplified line chart visualization */}
            <svg className="w-full h-full" data-id="element-427">
              <path d="M0,80 C50,60 100,90 150,40 C200,10 250,50 300,30" fill="none" stroke="#3b82f6" strokeWidth="2" data-id="element-428" />
            </svg>
            {/* Y-axis labels */}
            <div className="absolute left-0 top-0 h-full flex flex-col justify-between text-xs text-gray-500" data-id="element-429">
              <div data-id="element-430">$30M</div>
              <div data-id="element-431">$15M</div>
              <div data-id="element-432">$0</div>
            </div>
          </div>
          <div className="flex justify-between text-xs text-gray-500" data-id="element-433">
            <div data-id="element-434">Ene</div>
            <div data-id="element-435">Feb</div>
            <div data-id="element-436">Mar</div>
            <div data-id="element-437">Abr</div>
            <div data-id="element-438">May</div>
            <div data-id="element-439">Jun</div>
          </div>
        </Card>
        {/* Data Table */}
        <Card data-id="element-440">
          <div className="flex justify-between items-center mb-4" data-id="element-441">
            <h2 className="font-semibold" data-id="element-442">Detalle de acuerdos</h2>
            <button className="text-sm text-blue-600" data-id="element-443">Ver todos</button>
          </div>
          <div className="overflow-x-auto" data-id="element-444">
            <table className="min-w-full" data-id="element-445">
              <thead data-id="element-446">
                <tr className="border-b" data-id="element-447">
                  <th className="py-2 px-3 text-left text-sm font-medium text-gray-500" data-id="element-448">
                    ID
                  </th>
                  <th className="py-2 px-3 text-left text-sm font-medium text-gray-500" data-id="element-449">
                    Cliente
                  </th>
                  <th className="py-2 px-3 text-left text-sm font-medium text-gray-500" data-id="element-450">
                    Valor
                  </th>
                  <th className="py-2 px-3 text-left text-sm font-medium text-gray-500" data-id="element-451">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-452">
                {[{
                id: 'A001',
                client: 'Juan Rodríguez',
                value: '$2.45M',
                status: 'Activo'
              }, {
                id: 'A002',
                client: 'María López',
                value: '$1.83M',
                status: 'Pendiente'
              }, {
                id: 'A003',
                client: 'Pedro Gómez',
                value: '$0.95M',
                status: 'Vencido'
              }].map(item => <tr key={item.id} className="border-b" data-id="element-453">
                    <td className="py-2 px-3 text-sm" data-id="element-454">{item.id}</td>
                    <td className="py-2 px-3 text-sm" data-id="element-455">{item.client}</td>
                    <td className="py-2 px-3 text-sm" data-id="element-456">{item.value}</td>
                    <td className="py-2 px-3 text-sm" data-id="element-457">{item.status}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </main>
    </div>;
};
export default Reports;